import { Chip } from '@mui/material';
import OGARemarks from '../../../../views/crd/myworkspace/NewAdmissionRegister/components/OGAremarks';
import ToolTip from '../../../ToolTip/ToolTip';

const handleAssign = (params) => {
  return <ToolTip content={params.row.book_and_publication} expand={params.row.book_and_publication} />;
};
export const CRO_LEAD_TABLE_HEAD = [
  { field: 'sl_no', headerName: 'Sl No', width: 100 },
  { field: 'admn_no', headerName: 'Admn no', width: 100 },
  { field: 'name', headerName: 'Student Name', width: 250 },
  {
    field: 'assigned_course_name',
    headerName: 'Course Name',
    width: 250,
    renderCell: (params) => {
      return <ToolTip content={params.row.assigned_course_name} expand={params.row.assigned_course_name} />;
    },
  },
  { field: 'class', headerName: 'Class', width: 150 },
  // { field: "contactNumber", headerName: "Contact No", width: 150 },
  {
    field: 'contactNumber',
    headerName: 'Contact No',
    width: 150,
    renderCell: (params) => {
      const phone = params.value;
      const cleaned = String(phone || '').replace(/[^\d]/g, '');
      const valid = cleaned.length >= 10;

      if (!phone) return '—';

      return valid ? (
        <a
          href={`https://wa.me/${cleaned}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}
          onClick={(e) => e.stopPropagation()}
        >
          {phone}
        </a>
      ) : (
        <span style={{ color: '#9ca3af' }}>{phone}</span>
      );
    },
  },
  { field: 'place', headerName: 'Place', width: 150 },
  {
    field: 'book_and_publication',
    headerName: 'Book And Publication',
    width: 200,
    renderCell: handleAssign,
  },
  { field: 'total_sales_amount', headerName: 'Total Sales Amount', width: 180 },
  {
    field: 'collected_fee_inr',
    headerName: 'Collected Fee',
    width: 180,
    renderCell: (params) => {
      return params.row?.currency_type === 'INR'
        ? params.row?.collected_fee_inr + ' INR'
        : params.row?.collected_fee_aed + ' AED';
    },
  },
  { field: 'oga_name', headerName: 'OGA Name', width: 200 },
  {
    field: 'oga_remarks',
    headerName: 'OGA Remarks',
    width: 200,
    renderCell: (params) => {
      return (
        <OGARemarks
          CROAssignID={params.row.cro_assignment_id}
          name={params.row.name}
          contactNumber={params.row.contactNumber}
          classType={params.row.class}
          course={params.row.assigned_course_name}
        />
      );
    },
  },
  {
    field: 'total_session_count',
    headerName: 'Total Session Count',
    width: 200,
  },
  { field: 'assigned_by', headerName: 'Assigned CRM', width: 200 },
  { field: 'assigned_to', headerName: 'Assigned To CRO', width: 200 },
  { field: 'cro_assigned_on', headerName: 'CRO Assigned On', width: 200 },
  {
    field: 'student_status',
    headerName: 'Student Status',
    width: 200,
    renderCell: (params) => {
      if (params.row.student_status === 'Admission Confirmed') {
        return <Chip variant="outlined" color="success" label={params.row.student_status} />;
      } else {
        return <Chip variant="outlined" color="warning" label={params.row.student_status} />;
      }
    },
  },
  {
    field: 'exists_in_cart',
    headerName: 'Exist in Cart',
    width: 150,
    renderCell: (params) => {
      if (params.row.exists_in_cart === 1) {
        return <Chip variant="outlined" color="success" label="YES" />;
      } else {
        return <Chip variant="outlined" color="warning" label="NO" />;
      }
    },
  },
  {
    field: 'fee_term_informed_by_name',
    headerName: 'Fee Details Informed By',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_by_name === null ? (
        <Chip variant="outlined" color="warning" label="Not Updated" />
      ) : (
        params.row.fee_term_informed_by_name
      );
    },
  },
  {
    field: 'fee_term_informed_timestamp',
    headerName: 'Fee Details Informed On',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_timestamp === null ? (
        <Chip variant="outlined" color="warning" label="Not Updated" />
      ) : (
        params.row.fee_term_informed_timestamp
      );
    },
  },
];
export const CRO_LEAD_TABLE_HEAD_2026 = [
  { field: 'sl_no', headerName: 'Sl No', width: 100 },
  { field: 'admn_no', headerName: 'Admn no', width: 150 },
  { field: 'name', headerName: 'Student Name', width: 250 },
  {
    field: 'assigned_course_name',
    headerName: 'Course Name',
    width: 250,
    toolTipGetter: true,
  },
  { field: 'class', headerName: 'Class', width: 150 },
  {
    field: 'contactNumber',
    headerName: 'Contact No',
    width: 150,
    renderCell: (params) => {
      const phone = params.value;
      const cleaned = String(phone || '').replace(/[^\d]/g, '');
      const valid = cleaned.length >= 10;

      if (!phone) return '—';

      return valid ? (
        <a
          href={`https://wa.me/${cleaned}`}
          target="_blank"
          rel="noreferrer"
          style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 600 }}
          onClick={(e) => e.stopPropagation()}
        >
          {phone}
        </a>
      ) : (
        <span style={{ color: '#9ca3af' }}>{phone}</span>
      );
    },
  },
  { field: 'place', headerName: 'Place', width: 150 },
  {
    field: 'book_and_publication',
    headerName: 'Book And Publication',
    width: 200,
    toolTipGetter: true,
  },
  { field: 'oga_name', headerName: 'OGA Name', width: 200 },
  {
    field: 'oga_remarks',
    headerName: 'OGA Remarks',
    width: 200,
    type: 'action',
    actionType: 'view',
    actionKey: 'OGA Remarks',
  },
  {
    field: 'total_session_count',
    headerName: 'Total Session Count',
    width: 200,
  },
  { field: 'assigned_by', headerName: 'Assigned CRM', width: 200 },
  { field: 'assigned_to', headerName: 'Assigned To CRO', width: 200 },
  { field: 'cro_assigned_on', headerName: 'CRO Assigned On', width: 200 },
  {
    field: 'student_status',
    headerName: 'Student Status',
    width: 200,
    renderCell: (params) => {
      if (params.row.student_status === 'Admission Confirmed') {
        return <Chip variant="outlined" color="success" label={params.row.student_status} />;
      } else {
        return <Chip variant="outlined" color="warning" label={params.row.student_status} />;
      }
    },
  },
  {
    field: 'exists_in_cart',
    headerName: 'Exist in Cart',
    width: 150,
    renderCell: (params) => {
      if (params.row.exists_in_cart === 1) {
        return <Chip variant="outlined" color="success" label="YES" />;
      } else {
        return <Chip variant="outlined" color="warning" label="NO" />;
      }
    },
  },
  {
    field: 'fee_term_informed_by_name',
    headerName: 'Fee Details Informed By',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_by_name === null ? (
        <Chip variant="outlined" color="warning" label="Not Updated" />
      ) : (
        params.row.fee_term_informed_by_name
      );
    },
  },
  {
    field: 'fee_term_informed_timestamp',
    headerName: 'Fee Details Informed On',
    width: 200,
    renderCell: (params) => {
      return params.row.fee_term_informed_timestamp === null ? (
        <Chip variant="outlined" color="warning" label="Not Updated" />
      ) : (
        params.row.fee_term_informed_timestamp
      );
    },
  },
];
